// removed by extract-text-webpack-plugin
module.exports = {"timesheetPage":"styles__timesheetPage___1kWlH","adminPage":"styles__adminPage___xVzyj","tabArea":"styles__tabArea___1ZcHa","sideBar":"styles__sideBar___1jkX8","sideBarItem":"styles__sideBarItem___1htmg","selected":"styles__selected___2xndO","timesheetReviewArea":"styles__timesheetReviewArea___1z7Yb","reportPageHeader":"styles__reportPageHeader___1bGyb","reportPageTitle":"styles__reportPageTitle___1R2ls","reportWeekControl":"styles__reportWeekControl___3xxV4","submit":"styles__submit___EoB4G"};


//////////////////
// WEBPACK FOOTER
// ./src/app/styles.scss
// module id = 501
// module chunks = 0